module.exports = __webpack_public_path__ + "static/media/journeyFeedback.05500663.png";